import qs from 'qs'
import {
  getForm16FilesProps,
  getForm16FilesResponse,
  uploadFilesProps,
} from '../../../../types/Finance/FormSixteenUpload/FormSixteenUploadTypes'
import {
  getAuthenticatedRequestConfig,
  useAxios,
} from '../../../../utils/apiUtils'
import { AllowedHttpMethods, formSixteenUploadApiConfig } from '../../apiList'
import { ApiParams } from '../../../../types/commonTypes'

const getUploadForm16 = async (data: uploadFilesProps): Promise<number> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: formSixteenUploadApiConfig.uploadForm16,
    method: AllowedHttpMethods.post,
    data: data.file,
    params: {
      isFolder: data.isFolder,
      year: data.year,
    },
    additionalHeaders: {
      'Content-Type': 'multipart/form-data',
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const getForm16Files = async (
  data: getForm16FilesProps,
): Promise<getForm16FilesResponse> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: formSixteenUploadApiConfig.getForm16Files,
    method: AllowedHttpMethods.get,
    params: {
      startIndex: data?.startIndex,
      endIndex: data?.endIndex,
      year: data?.year,
      search: data?.search,
      status: data?.status,
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const deleteMultipleCheckedForm16Files = async (
  formIds: number[],
): Promise<number> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: formSixteenUploadApiConfig.deleteCheckedForm16Files,
    method: AllowedHttpMethods.delete,
    params: { formIds },
    paramsSerializer: (params: ApiParams) =>
      qs.stringify(params, { arrayFormat: 'repeat' }),
  })
  const response = await useAxios(requestConfig)
  return response.data
}

export const FormSixteenUploadApi = {
  getUploadForm16,
  getForm16Files,
  deleteMultipleCheckedForm16Files,
}

export default FormSixteenUploadApi
